import { render, staticRenderFns } from "./_FormEditarResposta.vue?vue&type=template&id=4f38856e&scoped=true"
import script from "./_FormEditarResposta.vue?vue&type=script&lang=ts"
export * from "./_FormEditarResposta.vue?vue&type=script&lang=ts"
import style0 from "./_FormEditarResposta.vue?vue&type=style&index=0&id=4f38856e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f38856e",
  null
  
)

export default component.exports